import React, { useEffect, useState, useRef } from 'react';
import { FaWhatsapp, FaPhoneAlt } from 'react-icons/fa';
import { FadeInFromLeft, ImageSlideIn } from '../../utils/HomePageFadeEffects';
import { CONTACT_INFO } from '../../config/constants';
// import Bg1 from '../../assets/mdlogo.png';
import { GodPhoto } from '../../data/photos';

export default function HomePageHeroCard() {

  const phone = CONTACT_INFO.mainPhone;
  const whatsapp = CONTACT_INFO.mainWhatsappLink;

  return (
    <section className="relative overflow-hidden py-8 md:py-32 bg-gradient-to-r from-slate-50 
    via-blue-100 to-slate-300">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center 
      gap-16">

        {/* Text Block */}
        <div className="pt-24 md:pt-8 md:w-1/2 max-w-xl md:text-left">
          <FadeInFromLeft delayClass="fade-delay-0">
            <h1 className="text-[2.4rem] md:text-[2.9rem] font-extrabold tracking-tight leading-tight 
            font-sans font-heading mb-6 select-none"
                style={{ textShadow: "0 4px 16px rgba(205,76,76,0.09)" }}>
              <span className="text-[3.4rem] md:text-[3.9rem] text-red-500 tracking-wide"> 
                24/7 Emergency </span>
              <br />
              <span className="text-sky-500">AMBULANCE SERVICE</span>
              <br />
              <span className="text-slate-900">at</span>{" "}
              <span className="text-slate-900"> Your Fingertips.</span>
            </h1>
          </FadeInFromLeft>

          <FadeInFromLeft delayClass="fade-delay-150">
            <p className="mb-3 pt-4 text-lg text-gray-700 tracking-wide select-none">
              Immediate help—your safety is our calling.
            </p>
          </FadeInFromLeft>

          <FadeInFromLeft delayClass="fade-delay-300">
            <p className="mb-8 text-slate-600 text-base select-none">
              Fast, reliable ambulance services across Bengaluru and Karnataka. Available in all areas, 
              day and night. We treat every call as urgent.
            </p>
          </FadeInFromLeft>

          <FadeInFromLeft delayClass="fade-delay-450">
            <div className="flex flex-col sm:flex-row gap-6 justify-center md:justify-start">
              <a href={`tel:${phone}`}
                 className="inline-flex items-center justify-center gap-2 tracking-widest rounded-lg 
                 bg-sky-600 px-8 py-4 text-white font-semibold text-lg hover:bg-sky-700 shadow-lg 
                 transition transform hover:scale-105 select-none animate-pulse">
                <FaPhoneAlt className="text-white text-xl animate-pulse" /> +91 {phone}
              </a>
              <a 
                 href={whatsapp}
                 target="_blank"
                 rel="noopener noreferrer"
                 className="inline-flex items-center justify-center gap-2 rounded-lg bg-[#25D366] 
                 border border-[#25D366] px-8 py-4 text-white font-semibold text-lg hover:bg-[#25D354] 
                 shadow transition transform hover:scale-105 select-none">
                <FaWhatsapp className="text-white text-3xl" /> WhatsApp
              </a>
            </div>
          </FadeInFromLeft>
        </div>

        {/* Hero Image with Slide-in from right */}
        <div className="md:w-1/2 flex justify-center max-w-full overflow-hidden">
          <ImageSlideIn src={GodPhoto} />
        </div>
      </div>
    </section>
  );
}
